import { SCREENS_ROUTES_ENUMS } from 'common/enum';
import { ConfigurationContext } from 'components/provider/OrginazationContext';
import NepaliDatePicker from 'components/ui/Datepicker/Datepicker';
import { BSToAD } from 'components/ui/Datepicker/Datepickerutils';

import CustomSelect from 'components/ui/Editor/CustomSelect3';
import PrimaryButton from 'components/ui/PrimaryButton';
import TextInput from 'components/ui/TextInput';
import { useFormik } from 'formik';
import getDoaminName from 'lib/getDomainName';
import moment from 'moment';
import { useContext, useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSignUpMutation } from 'redux/reducers/auth';
import { useListDynamicFieldsOfTraineeQuery } from 'redux/reducers/form-fields';
import { useListDistrictByProvinceQuery, useListProvinceQuery } from 'redux/reducers/geography';
import { backendURL, nascsubdomain, trainingsubdomain } from 'redux/reducers/settings';
import validations from 'utils/validation';
import * as Yup from 'yup';

const SignUpValidationSchema = {
  first_name: Yup.string().required('First Name is required'),
  last_name: Yup.string().required('Last Name is required'),
  citizenship_no: Yup.string().optional(),
  middle_name: Yup.string().nullable(),
  gender: Yup.string().required('Gender is required'),
  password: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Password is required'),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('password'), null], "Password doesn't Match")
    .required('Required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  dob: Yup.string().required('DOB is required'),
  mobile_number: Yup.string()
    .matches(validations.phone.regex, validations.phone.message)
    .required('Mobile Number is required'),
  province_id: Yup.string().nullable(),
  district_id: Yup.string().nullable(),
  employee_sn: Yup.string().optional(),
  passport_number: Yup.string().optional(),
  working_organization_name: Yup.string().optional(),
  qualification: Yup.string().optional(),
  namc_or_nhpc: Yup.string().optional(),
  recommendation_letter: Yup.mixed().nullable(),
  pan_number: Yup.string().optional(),
  dob_bs: Yup.string().nullable()
};

const option1 = [
  { value: '1', label: 'Male' },
  { value: '2', label: 'Female' },
  { value: '3', label: 'Others' }
];

const SignUp = () => {
  let navigate = useNavigate();
  const [passwordToogle, setPasswordToogle] = useState('password');
  const togglePassword = () => {
    if (passwordToogle === 'password') {
      setPasswordToogle('text');
      return;
    }
    setPasswordToogle('password');
  };
  const [page, setPage] = useState(1);

  const [province, setProvince] = useState<any>('');
  const [districts, setDistricts] = useState<any[]>([]);

  const { data: provinceList = [] } = useListProvinceQuery({});

  const { data: districtData } = useListDistrictByProvinceQuery(
    {
      provinceId: province,
      page
    },
    {
      skip: !province
    }
  );

  const [cPasswordToogle, setCPasswordToogle] = useState('password');
  const cTogglePassword = () => {
    if (cPasswordToogle === 'password') {
      setCPasswordToogle('text');
      return;
    }
    setCPasswordToogle('password');
  };

  const { data: traineeDynamicFields } = useListDynamicFieldsOfTraineeQuery();
  const [signUp, { isLoading }] = useSignUpMutation();
  const dynamicFieldsValidations: any = {};
  traineeDynamicFields?.map((item: any) => {
    dynamicFieldsValidations[item.fieldname] =
      item.field_type_details.title === 'number'
        ? item.is_required
          ? Yup.number().required(`${item.fieldname} is required`)
          : Yup.number()
        : item.is_required
          ? Yup.string().required(`${item.fieldname} is required`)
          : Yup.string();
  });

  interface IInitialValue {
    email: string;
    password: string;
    confirm_password: string;
    first_name: string;
    middle_name?: string;
    last_name: string;
    mobile_number: string;
    citizenship_no: string;
    dob: string;
    gender: string;
    province_id: string;
    district_id: string;
    employee_sn: string;
    passport_number: string;
    working_organization_name: string;
    qualification: string;
    namc_or_nhpc: string;
    recommendation_letter: string;
    pan_number: string;
    dob_bs: string
  }

  const initialValue: IInitialValue = {
    email: '',
    password: '',
    confirm_password: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    mobile_number: '',
    citizenship_no: '',
    gender: '',
    dob: '',
    dob_bs: '',
    province_id: '',
    district_id: '',
    employee_sn: '',
    passport_number: '',
    working_organization_name: '',
    qualification: '',
    namc_or_nhpc: '',
    recommendation_letter: '',
    pan_number: ''
  };

  const formik = useFormik({
    validationSchema: Yup.object().shape({
      ...SignUpValidationSchema
      //   ...dynamicFieldsValidations
    }),
    initialValues: initialValue,
    onSubmit: (values) => {
      signUp({ ...values })
        .unwrap()
        .then(() => {
          toast.success('Registration Successful');
          navigate(SCREENS_ROUTES_ENUMS.USER_SIGN);
        })
        .catch((err: any) => {
          toast.error(err?.data?.message);


        });
    }
  });

  useEffect(() => {
    if (districtData) {
      setDistricts((oldData) => [...oldData, ...districtData?.districts]);
    }
  }, [districtData]);

  useEffect(() => {
    setProvince(formik.values.province_id);
  }, [formik.values.province_id]);

  const siteName = getDoaminName();

  const { appConfig } = useContext(ConfigurationContext);
  console.log(formik.errors);

  return (
    <div className="container-fluid p-0">
      <div className="row g-0 min-vh-100">
        {/* LEFT SIDE: Image Section */}
        <div className="col-lg-6 d-none d-lg-block position-relative">
          {appConfig?.register_image ? (
            <img
              src={backendURL + appConfig.register_image}
              alt="auth-bg"
              style={{
                width: '100%',
                height: '100vh',
                objectFit: 'cover',
                position: 'sticky',
                top: 0
              }}
            />
          ) : (
            <div
              className="bg-primary w-100 h-100 d-flex align-items-center justify-content-center"
              style={{ minHeight: '100vh' }}>
              <h1 className="text-white">Welcome</h1>
            </div>
          )}
        </div>

        <div className="col-lg-6  overflow-auto" style={{ maxHeight: '100vh' }}>
          <div className="p-lg-5 p-4 mx-auto" style={{ maxWidth: '600px' }}>
            <div>
              <h2 className="text-primary">{appConfig?.title}</h2>

              <h5 className="text-primary">Register Account</h5>
              <p className="text-muted">Fill up the field and register your account now</p>
            </div>

            <div className="mt-4">
              <form onSubmit={formik.handleSubmit}>
                <div className="d-flex gap-2 mb-3">
                  <TextInput
                    label="First Name"
                    name="first_name"
                    containerClassName="w-100"
                    type="text"
                    onChange={formik.handleChange}
                    value={formik.values.first_name}
                    onBlur={formik.handleBlur}
                    formik={formik}
                  />
                  <TextInput
                    label="Middle Name"
                    name="middle_name"
                    containerClassName="w-100"
                    type="text"
                    onChange={formik.handleChange}
                    value={formik.values.middle_name}
                    onBlur={formik.handleBlur}
                    formik={formik}
                    disableRequiredValidation={true}


                  />
                  <TextInput
                    label="Last Name"
                    name="last_name"
                    containerClassName="w-100"
                    type="text"
                    onChange={formik.handleChange}
                    value={formik.values.last_name}
                    onBlur={formik.handleBlur}
                    formik={formik}
                  />
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <CustomSelect
                      options={option1}
                      placeholder={'Select gender'}
                      value={formik.values.gender}
                      onChange={(value: any) => {
                        formik.setFieldValue('gender', value);
                      }}
                      label={'Gender'}
                      containerClassName="w-100"
                    />
                  </div>
                  <NepaliDatePicker
                    containerClassName="col-md-6"
                    label="DOB"
                    name="dob_bs"
                    onChange={(e) => {
                      formik.setFieldValue('dob_bs', e);
                      formik.setFieldValue('dob', moment(BSToAD(e)).format('YYYY-MM-DD'));
                    }}
                    value={formik.values.dob_bs}
                  />
                </div>

                <div className="d-flex gap-2">
                  <TextInput
                    label="Citizenship No"
                    name="citizenship_no"
                    containerClassName="w-100 mb-3"
                    onChange={formik.handleChange}
                    value={formik.values.citizenship_no}
                    onBlur={formik.handleBlur}
                    formik={formik}
                  />
                  <TextInput
                    label="Email"
                    name="email"
                    type="email"
                    containerClassName="w-100 mb-3"
                    onChange={formik.handleChange}
                    value={formik.values.email}
                    onBlur={formik.handleBlur}
                    formik={formik}
                  />
                </div>

                <div className="d-flex gap-2">
                  <TextInput
                    label="Mobile No"
                    name="mobile_number"
                    containerClassName="w-100 mb-3"
                    onChange={formik.handleChange}
                    value={formik.values.mobile_number}
                    onBlur={formik.handleBlur}
                    formik={formik}
                  />
                  <div className="w-100 position-relative auth-pass-inputgroup mb-3">
                    <TextInput
                      label="Password"
                      name="password"
                      type={passwordToogle}
                      containerClassName="w-100"
                      onChange={formik.handleChange}
                      value={formik.values.password}
                      onBlur={formik.handleBlur}
                      formik={formik}
                    />
                    <button
                      className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                      type="button"
                      onClick={togglePassword}
                      style={{ marginTop: '30px', zIndex: 10 }}>
                      <i className="ri-eye-fill align-middle"></i>
                    </button>
                  </div>
                </div>

                {/* Confirm Password and Province */}
                <div className="d-flex gap-2">
                  <div className="w-100 position-relative auth-pass-inputgroup mb-3">
                    <TextInput
                      label="Confirm Password"
                      name="confirm_password"
                      type={cPasswordToogle}
                      containerClassName="w-100"
                      onChange={formik.handleChange}
                      value={formik.values.confirm_password}
                      onBlur={formik.handleBlur}
                      formik={formik}
                    />
                    <button
                      className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                      type="button"
                      onClick={cTogglePassword}
                      style={{ marginTop: '30px', zIndex: 10 }}>
                      <i className="ri-eye-fill align-middle"></i>
                    </button>
                  </div>

                  {siteName == trainingsubdomain && (
                    <div className="w-100 mt-3">
                      <label className="form-label">Province</label>
                      <select
                        name="province_id"
                        className="form-select"
                        value={formik.values.province_id}
                        onChange={(e) => {
                          setPage(1);
                          setDistricts([]);
                          formik.handleChange(e);
                        }}>
                        <option value="">Choose...</option>
                        {provinceList.map((province, index) => (
                          <option key={index} value={province.id}>
                            {province.name_en}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>

                {/* Training Specific Fields (Logic preserved) */}
                {siteName == trainingsubdomain && (
                  <>
                    <div className="d-flex gap-2 mb-3">
                      <div className="w-100">
                        <label className="form-label">District</label>
                        <select
                          name="district_id"
                          className="form-select"
                          value={formik.values.district_id}
                          onChange={formik.handleChange}>
                          <option value="">Choose...</option>
                          {districts?.map((d, index) => (
                            <option key={index} value={d.id}>
                              {d.name_en}
                            </option>
                          ))}
                        </select>
                      </div>
                      <TextInput
                        containerClassName="w-100"
                        label="Employee SN"
                        name="employee_sn"
                        onChange={formik.handleChange}
                        value={formik.values.employee_sn}
                        onBlur={formik.handleBlur}
                        formik={formik}
                        disableRequiredValidation
                      />
                    </div>
                    {/* ... other dynamic fields (Namc/Nhpc, Pan, Qualification) ... */}
                  </>
                )}

                {/* File Upload */}
                <div className="col-12 mt-3 mb-4">
                  <label className="form-label">Recommendation letter</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => {
                      formik.setFieldValue('recommendation_letter', e.target.files?.[0] ?? null);
                    }}
                  />
                </div>

                <div className="mt-4">
                  <PrimaryButton
                    isLoading={isLoading}
                    title="Register"
                    type="submit"
                    className="w-100 btn btn-primary py-2"
                  />
                </div>
              </form>
            </div>

            <div className="mt-5 text-center">
              <p className="mb-0">
                Already have an account ?{' '}
                <span
                  onClick={() => navigate(SCREENS_ROUTES_ENUMS.USER_SIGN)}
                  className="fw-semibold text-primary text-decoration-underline"
                  style={{ cursor: 'pointer' }}>
                  Signin
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;

{
  /* <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
      <div className="bg-overlay" />
      <div className="auth-page-content overflow-hidden pt-lg-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="card overflow-hidden m-0">
                <div className="row justify-content-center g-0">
                  <div className="col-lg-6">
                    <div className="p-lg-5 p-4 auth-one-bg h-100 position-relative overflow-hidden">
                      {appConfig?.register_image && (
                        <img
                          src={backendURL + appConfig.register_image}
                          alt="auth-bg"
                          style={{
                            position: 'absolute',
                            justifyContent: 'center',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            zIndex: 0
                          }}
                        />
                      )}
                      <div className="bg-overlay" />
                      <div className="position-relative h-100 d-flex flex-column">
                        <div className="mt-auto">
                          <div className="mb-3">
                            <i className="ri-double-quotes-l display-4 text-success" />
                          </div>
                          <div
                            id="qoutescarouselIndicators"
                            className="carousel slide"
                            data-bs-ride="carousel">
                            <div className="carousel-indicators">
                              <button
                                type="button"
                                data-bs-target="#qoutescarouselIndicators"
                                data-bs-slide-to={0}
                                className="active"
                                aria-current="true"
                                aria-label="Slide 1"
                              />
                              <button
                                type="button"
                                data-bs-target="#qoutescarouselIndicators"
                                data-bs-slide-to={1}
                                aria-label="Slide 2"
                              />
                              <button
                                type="button"
                                data-bs-target="#qoutescarouselIndicators"
                                data-bs-slide-to={2}
                                aria-label="Slide 3"
                              />
                            </div>
                            <div className="carousel-inner text-center text-white-50 pb-5">
                              <div className="carousel-item active">
                                <p className="fs-15 fst-italic">
                                  " Create Assignment, Courses and Training "
                                </p>
                              </div>
                              <div className="carousel-item">
                                <p className="fs-15 fst-italic">
                                  " Assign Coordinator and Evaluator to the routine"
                                </p>
                              </div>
                              <div className="carousel-item">
                                <p className="fs-15 fst-italic">
                                  " Add trainee, coordinator and evaluator in the system "
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="p-lg-5 p-4">
                      <div>
                        <h5 className="text-primary">Register Account</h5>
                        <p className="text-muted">
                          Fill up the field and register your account now
                        </p>
                      </div>
                      <div className="mt-4">
                        <form onSubmit={formik.handleSubmit}>
                          <div className="d-flex gap-2">
                            <TextInput
                              label="First Name"
                              name="first_name"
                              containerClassName="mb-3"
                              type="text"
                              onChange={formik.handleChange}
                              value={formik.values.first_name}
                              onBlur={formik.handleBlur}
                              formik={formik}
                            />
                            <TextInput
                              label="Middle Name"
                              name="middle_name"
                              containerClassName="mb-3"
                              type="text"
                              onChange={formik.handleChange}
                              value={formik.values.middle_name}
                              onBlur={formik.handleBlur}
                              formik={formik}
                            />

                            <TextInput
                              label="Last Name"
                              name="last_name"
                              containerClassName="mb-3"
                              type="text"
                              onChange={formik.handleChange}
                              value={formik.values.last_name}
                              onBlur={formik.handleBlur}
                              formik={formik}
                            />
                          </div>
                          <div className="d-flex gap-2">
                            <CustomSelect
                              options={option1}
                              placeholder={'Select gender'}
                              value={formik.values.gender}
                              onChange={(value: any) => {
                                formik.setFieldValue('gender', value);
                              }}
                              label={'Gender'}
                            />
                            <div className="w-full mt-3 col-12">
                              <NepaliDatePicker
                                className=""
                                containerClassName="col-6"
                                label="DOB"
                                name="DOB"
                                onChange={(e) => {
                                  formik.setFieldValue('dob', e);
                                  formik.setFieldValue(
                                    'dob_ad',
                                    moment(BSToAD(e)).format('YYYY-MM-DD')
                                  );
                                }}
                                value={formik.values.dob}
                              />
                            </div>
                          </div>
                          <div className="d-flex gap-2 mt-3">
                            <TextInput
                              label="Citizenship No"
                              name="citizenship_no"
                              type="text"
                              containerClassName="mb-3"
                              onChange={formik.handleChange}
                              value={formik.values.citizenship_no}
                              onBlur={formik.handleBlur}
                              formik={formik}
                            />

                            <TextInput
                              label="Email"
                              name="email"
                              type="email"
                              containerClassName="mb-3"
                              onChange={formik.handleChange}
                              value={formik.values.email}
                              onBlur={formik.handleBlur}
                              formik={formik}
                            />
                          </div>
                          <div className="d-flex gap-2">
                            <TextInput
                              label="Mobile No"
                              name="mobile_number"
                              type="text"
                              containerClassName="mb-3"
                              onChange={formik.handleChange}
                              value={formik.values.mobile_number}
                              onBlur={formik.handleBlur}
                              formik={formik}
                            />
                            <div className="position-relative auth-pass-inputgroup mb-3">
                              <TextInput
                                label="Password"
                                name="password"
                                type={passwordToogle}
                                containerClassName="mb-3"
                                onChange={formik.handleChange}
                                value={formik.values.password}
                                onBlur={formik.handleBlur}
                                formik={formik}
                              />
                              <button
                                className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                type="button"
                                id="password-addon">
                                <i
                                  className="ri-eye-fill align-middle"
                                  onClick={togglePassword}
                                  style={{ position: 'absolute', top: 35, right: 10 }}></i>
                              </button>
                            </div>
                          </div>
                          <div className="d-flex gap-2">
                            <div className="position-relative auth-pass-inputgroup mb-3">
                              <TextInput
                                label="Confirm Password"
                                name="confirm_password"
                                type={cPasswordToogle}
                                containerClassName="mb-3"
                                onChange={formik.handleChange}
                                value={formik.values.confirm_password}
                                onBlur={formik.handleBlur}
                                formik={formik}
                              />
                              <button
                                className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                type="button"
                                id="password-addon">
                                <i
                                  className="ri-eye-fill align-middle"
                                  onClick={cTogglePassword}
                                  style={{ position: 'absolute', top: 35, right: 10 }}></i>
                              </button>
                            </div>
                            {siteName == trainingsubdomain && (
                              <div className=" col-md-6">
                                <div className="">
                                  <label htmlFor="province" className="form-label">
                                    Province
                                  </label>
                                  <select
                                    name="province_id"
                                    id="province"
                                    className="form-select col-md-12"
                                    data-choices
                                    data-choices-sorting="true"
                                    value={formik.values.province_id}
                                    onChange={(e) => {
                                      setPage(1);
                                      setDistricts([]);
                                      formik.handleChange(e);
                                    }}>
                                    <option selected>Choose...</option>
                                    {provinceList.map((province, index) => {
                                      return (
                                        <option key={index} value={province.id}>
                                          {province.name_en}
                                        </option>
                                      );
                                    })}
                                  </select>

                                  {formik.touched?.province_id && formik.errors?.province_id && (
                                    <span className="text-danger">
                                      {formik.errors?.province_id}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          {siteName == trainingsubdomain && (
                            <div className="d-flex gap-2">
                              <div className=" col-md-6">
                                <div className="">
                                  <label htmlFor="district" className="form-label">
                                    District
                                  </label>
                                  <select
                                    name="district_id"
                                    id="district_id"
                                    className="form-select col-md-12"
                                    data-choices
                                    data-choices-sorting="true"
                                    value={formik.values.district_id}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                    }}>
                                    <option selected>Choose...</option>
                                    {districts &&
                                      districts?.length > 0 &&
                                      districts?.map((d, index) => {
                                        return (
                                          <option key={index} value={d.id}>
                                            {d.name_en}
                                          </option>
                                        );
                                      })}
                                  </select>

                                  {formik.touched.district_id && formik.errors.district_id && (
                                    <span className="text-danger">{formik.errors.district_id}</span>
                                  )}
                                </div>
                              </div>
                              <TextInput
                                containerClassName="col-md-6"
                                label="Employee SN"
                                name="employee_sn"
                                type="text"
                                onChange={formik.handleChange}
                                value={formik.values.employee_sn}
                                onBlur={formik.handleBlur}
                                formik={formik}
                                disableRequiredValidation
                              />
                            </div>
                          )}

                          {siteName == trainingsubdomain && (
                            <>
                              <div className="d-flex gap-2">
                                <TextInput
                                  containerClassName="col-md-6"
                                  label="Namc / Nhpc"
                                  name="namc_or_nhpc"
                                  type="text"
                                  onChange={formik.handleChange}
                                  value={formik.values.namc_or_nhpc}
                                  onBlur={formik.handleBlur}
                                  formik={formik}
                                  disableRequiredValidation
                                />
                                <TextInput
                                  containerClassName="col-md-6"
                                  label="Pan number"
                                  name="pan_number"
                                  type="text"
                                  onChange={formik.handleChange}
                                  value={formik.values.pan_number}
                                  onBlur={formik.handleBlur}
                                  formik={formik}
                                  disableRequiredValidation
                                />
                              </div>
                              <div className="d-flex gap-2">
                                <TextInput
                                  containerClassName="col-md-6"
                                  label="Qualification"
                                  name="qualification"
                                  type="text"
                                  onChange={formik.handleChange}
                                  value={formik.values.qualification}
                                  onBlur={formik.handleBlur}
                                  formik={formik}
                                  disableRequiredValidation
                                />
                                <TextInput
                                  containerClassName="col-md-6"
                                  label="Working organization"
                                  name="working_organization_name"
                                  type="text"
                                  onChange={formik.handleChange}
                                  value={formik.values.working_organization_name}
                                  onBlur={formik.handleBlur}
                                  formik={formik}
                                  disableRequiredValidation
                                />
                              </div>
                            </>
                          )}

                          <div className="col-12 mt-3">
                            <label>Recommendation letter</label>
                            <input
                              id="profile-img-file-input"
                              type="file"
                              className="form-control"
                              name="image"
                              onChange={(e) => {
                                formik.handleChange({
                                  target: {
                                    name: 'recommendation_letter',
                                    value: e.target.files?.[0] ?? null
                                  }
                                });
                              }}
                            />
                          </div>
                          {formik.values.recommendation_letter && (
                            <img
                              src={formik.values.recommendation_letter}
                              className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                              alt="user-profile-image"
                            />
                          )}

                          <div className="hstack gap-2 justify-center mt-4">
                            <PrimaryButton
                              isLoading={isLoading}
                              title="Register"
                              type="submit"
                              className="w-100"
                            />
                          </div>
                        </form>
                      </div>
                      <div className="mt-5 text-center">
                        <p className="mb-0">
                          Already have an account ?{' '}
                          <a
                            onClick={() => navigate(SCREENS_ROUTES_ENUMS.USER_SIGN)}
                            className="fw-semibold text-primary text-decoration-underline">
                            {' '}
                            <span style={{ cursor: 'pointer' }}> Signin </span>
                          </a>{' '}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center">
                <p className="mb-0">© All Right Reserved</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div> */
}
